<eo-base-form-control
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-dropdown
    attr.aria-describedby="{{ id }}-help"
    styleClass="w-full {{ getInputStyleClass() }}"
    [id]="id"
    [tabindex]="getTabIndex()"
    [options]="getOptions()"
    [optionLabel]="getOptionLabel()"
    [optionValue]="getOptionValue()"
    [placeholder]="getPlaceholder()"
    [formControl]="getFormControl()"
    [showClear]="getShowClear()"
    [dropdownIcon]="getDropdownIcon()"
    [filter]="hasFilter()"
    [filterBy]="getFilterBy()"
    [filterFields]="getFilterFields()"
    [filterPlaceholder]="getFilterPlaceholder()"
    [appendTo]="getAppendTo()"
    [virtualScroll]="getVirtualScroll()"
    [virtualScrollItemSize]="getVirtualScrollSize()"
    [group]="getGroup()"
    [loading]="getLoading()"
    [lazy]="getLazy()"
    (onLazyLoad)="onLazyLoad($event)"
    (onRemove)="onRemoveHandler()"
    (onChange)="onChangeHandler($event)"
    (onFocus)="onFocusHandler($event)"
    (onBlur)="onBlurHandler($event)"
    (onFilter)="onFilterHandler($event)"
  >
    <ng-content />
  </p-dropdown>
</eo-base-form-control>

<!-- (onChange)="change.emit($event)"
    (onFocus)="focus.emit($event)"
    (onBlur)="blur.emit($event)" -->
